(($, Drupal, drupalSettings, autoComplete) => {
  function waitForEl(selector, callback, maxtries = false, interval = 100){
    const poller = setInterval(() => {
      const el = $(selector)
      const retry = maxtries === false || maxtries-- > 0
      if (retry && el.length < 1) return // will try again
      clearInterval(poller)
      callback(el || null)
    }, interval)
  }
  Drupal.behaviors.plusterveys = {
    attach: (context, settings) => {
      // $(context.querySelectorAll('#block-headercollectionforstructurechanges .block-views-exposed-filter-blocksite-search-search-page')).once('searchAutocomplete').each( (index, item) => {
      $(once('searchAutocomplete', '#block-headercollectionforstructurechanges .block-views-exposed-filter-blocksite-search-search-page')).each( (index, item) => {
        const textInput = item.querySelector('input[type=text]');
        // initialize
        var my_autoComplete = new autoComplete({
          selector: textInput,
          source: function(term, suggest){
            try {
              Drupal.behaviors.plusterveys.xhr.abort();
            } catch(e){

            }
            Drupal.behaviors.plusterveys.xhr = $.getJSON('/autocomplete-search', {
              q: term,
            }, data => {
              suggest(data)
            });
          },
          renderItem: function (item, search){
            console.log(item);
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            return '<div class="autocomplete-suggestion" data-url="'+item.url+'" data-title="'+item.title+'"> '+item.title.replace(re, "<b>$1</b>")+'</div>';
          },
          onSelect: function(e, term, item){
            window.location.href = item.getAttribute('data-url');
          }
        });
      });


      // Initialize CTA-link list on subpages. The CTA-link gets as href the value of the selected option
      // $(".paragraph--type--cta-link-list").once('initialize-cta-links-list').each((index, item) => {
      $(once('initialize-cta-links-list', ".paragraph--type--cta-link-list")).each((index, item) => {

        let optionList = $(item).find("SELECT.cta-link-list")[0];
        let link = $(item).find(".cta-link A.button");
        let minWidth = Math.max($(optionList).outerWidth(), $(link).outerWidth());

        optionList.value = 0;

        $(optionList).css("min-width", minWidth + "px");
        $(link).css("min-width", minWidth + "px");

        $(optionList).on("change", () => {
          if(optionList.value === "0") {

            if(link.hasClass('visible')) {
              link.removeClass("visible");
            }

          }
          else {

            link.attr("href", optionList.value);

            if(!link.hasClass('visible')) {
              link.addClass("visible");
            }

          }
        });
      });


      // $(context.querySelectorAll('.jBox-content')).once('hide-scrollBar').each( (index,item) => {
      $(once('hide-scrollBar', '.jBox-content')).each( (index,item) => {
        imagesLoaded( item, e => {
          const child = item.querySelector('.wrapper');
          const scrollBarWidth = (child.clientWidth - child.offsetWidth) * -1;
          child.style.width = 'calc(100% + ' + scrollBarWidth + 'px)';
        });
      });

      // $(context.querySelectorAll('.expandable')).once('add-listeners').each( (index,item) => {
      $(once('add-listeners', '.expandable')).each( (index,item) => {
        item.querySelector('a').addEventListener('click', e => {
          e.preventDefault();
          var el = e.srcElement;
          if(!el.classList.contains('expanded')) {
            el.classList.add('expanded');
          }
          else {
            el.classList.remove('expanded');
          }
          var div = item.querySelector('div');
          div.style.display = div.style.display === 'none' ? 'block' : 'none';
        });
      });

      // $(context.querySelectorAll('.field--name-field-how-to-arrive'))
      //   .once('howtoarrive')
      $(once('howtoarrive', '.field--name-field-how-to-arrive'))
        .each( (index,item) => {
          var hidedField = item.querySelector('.field__item');
          var toggleLabel = item.querySelector('.field__label');
          if (toggleLabel && hidedField) {
            hidedField.style.display = "none";
            toggleLabel.addEventListener('click', e => {
              toggleLabel.parentElement.classList.toggle('open');
              $(hidedField).slideToggle();
            });
          }

        });


      // $(document).once('waitForMobileEl').each(() => {
      //   waitForEl('.sf-accordion', () => {
      //     $('.sf-accordion').once().each( (index,item) => {
      //       var main_nav = $(item);
      $(once('waitForMobileEl', "body", context)).each(() => {
        waitForEl('.sf-accordion', () => {
          $(once('sf-accordion', '.sf-accordion')).each( (index,item) => {
            var main_nav = $(item);
            main_nav.find("a.sf-depth-1.menuparent,a.sf-depth-2.menuparent").each(function(index, items){
              var t = $(items);
              var click = $._data(items, "events");
              if( typeof click == 'undefined' ){
              }else{
                $(click.click).each(function(x,y){
                  t.data("click",y.handler.bind(t.get(0)));
                });
              }
              t.off("click");
              t.on('click', e => {
                if( !t.hasClass('clicked') ){
                  e.preventDefault();
                  t.addClass('clicked');
                  t.data("click")(e);
                }
              })
            });
          })
        },
        100);
      });
    }
  }

})(jQuery, Drupal, drupalSettings, autoComplete);
